import Bone from "../../../../Components/Skeleton/Bone"

import styles from "./programPanel.module.less"

// The program rows in their own classes: the 32px brand mark, the two 22px text lines (name
// and share, lookups and match rate) and the 8px bar.
const ProgramPanelSkeleton = ({ count }) => (
  <div className={styles.list}>
    {Array.from({ length: count }, (_, i) => (
      <div key={i} className={styles.row}>
        <Bone width={32} height={32} radius={6} />
        <div className={styles.main}>
          <div className={`${styles.line} ${styles.skeletonLine}`}>
            <Bone width={120} height={14} />
            <Bone width={32} height={14} />
          </div>
          <div className={`${styles.line} ${styles.skeletonLine}`}>
            <Bone width={150} height={14} />
            <Bone width={100} height={14} />
          </div>
          <div className={styles.bar} />
        </div>
      </div>
    ))}
  </div>
)

export default ProgramPanelSkeleton
